import { Link } from "react-router-dom";
import { supportWays } from "@/mocks/contactData";
import Icon from "@/components/feature/Icon";

export default function SupportSection() {
  return (
    <section className="py-16 md:py-24 bg-silver-50">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl mb-12 md:mb-16">
          <p className="text-sm font-medium tracking-[0.2em] text-navy-700 uppercase mb-3">
            Support TAIAA
          </p>
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-semibold text-navy-950 mb-4">
            支持協會的方式
          </h2>
          <p className="text-silver-500 text-base md:text-lg leading-relaxed">
            TAIAA 的每一步成長，都來自會員與夥伴的支持。您可以透過以下任一方式，與我們一起推動台灣 AI 應用發展。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {supportWays.map((way, idx) => (
            <div
              key={way.title}
              className={`group bg-white border border-silver-200 rounded-xl p-6 md:p-8 hover:border-navy-300 transition-all duration-300 ${
                idx === 0 ? "md:row-span-1" : ""
              }`}
            >
              <div className="flex items-start gap-4 md:gap-5">
                <div className="w-12 h-12 rounded-xl bg-navy-950 flex items-center justify-center flex-shrink-0 group-hover:scale-105 transition-transform">
                  <Icon className={`${way.icon} text-white text-xl`} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-navy-950 font-semibold text-base md:text-lg mb-2">
                    {way.title}
                  </h3>
                  <p className="text-silver-500 text-sm leading-relaxed mb-4">
                    {way.description}
                  </p>
                  {way.actionPath.startsWith("/") ? (
                    <Link
                      to={way.actionPath}
                      className="inline-flex items-center gap-1.5 text-navy-800 text-sm font-medium hover:text-navy-950 transition-colors"
                    >
                      {way.action}
                      <Icon className="ri-arrow-right-line text-xs" />
                    </Link>
                  ) : (
                    <a
                      href={way.actionPath}
                      className="inline-flex items-center gap-1.5 text-navy-800 text-sm font-medium hover:text-navy-950 transition-colors"
                    >
                      {way.action}
                      <Icon className="ri-arrow-right-line text-xs" />
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}